/**
 * Created by stonewang on 2017/8/15.
 */
import React from 'react';
import Reflux from 'reflux';
import { Button, message, Modal } from 'antd';
import { hashHistory, withRouter } from 'react-router';
import { DmsTab, TableView, UploadFile } from 'Components';
import { getList, deleteFiles, addFileDownCount } from '../../service/remark/file'
import { FileActions as Actions, FileStore as Store } from './fileStore';
import { config } from 'Utils';
const confirm = Modal.confirm;

class FileList extends Reflux.Component {
  constructor (props) {
    super(props);
    const entityId = parseInt(this.props.location.query.entityId, 10);
    const entityType = this.props.location.query.entityType;
    let dealType = '';
    switch (entityType) {//1-渠道；2-渠道联系人；3-门店；4-门店店员
      case 'channel':
        dealType = 1;
        break;
      case 'linkman':
        dealType = 2;
        break;
      case 'store':
        dealType = 3;
        break;
      case 'staff':
        dealType = 4;
        break;
      default:
        break;
    }

    this.store = Reflux.initStore(Store); //创建一个Store实例
    this.state = {
      entityId,
      entityType,
      rows: [],
      total: 0,
      searchObj: {
        id: entityId,
        dealType,
        p: 1,
        s: 10,
      }
    };
    this.getData = this.getData.bind(this);
    this.pageChange = this.pageChange.bind(this);
    this.routeLeaveHook = this.routeLeaveHook.bind(this);
  }

  routeLeaveHook (nextLocation) {
    let path = nextLocation.pathname.split('/');
    if (path[1] === 'staff' && path[3] !== 'add') { //当下一个路由是详情页时，将useStore的值设为true
      Actions.useStoreChange(true);
      Actions.paramChange(this.state.searchObj);
    } else {
      Actions.useStoreChange(false);
      Actions.paramChange({});
    }
  }

  componentWillMount () {
    const data = this.store.state;
    if (data.useStore) { //根据useStore的值判断是否使用store中的数据
      this.setState({
        ...this.state,
        searchObj: {
          ...this.state.searchObj,
          ...data.params,
        }
      });
    }
  }

  componentDidMount () {
    this.getData();
    //设置离开当前路由时的钩子函数
    this.props.router.setRouteLeaveHook(this.props.route, this.routeLeaveHook);
  }

  getData () {
    const self = this;
    const { searchObj } = this.state;
    getList(searchObj).then(res => {
      if (res.status) {
        self.setState({ total: res.total, rows: res.data });
      } else {
        console.error(res.message);
      }
    });
  }

  goView (url) {
    hashHistory.push(url);
  }

  goBack () {
    hashHistory.goBack();
  }

  pageChange (page, pageSize) {
    const self = this;
    this.setState({ searchObj: { ...this.state.searchObj, s: pageSize, p: page } }, function () {
      self.getData();
    });
  }

  deleteFile (id) {
    const self = this;
    confirm({
      title: '确定要删除附件?',
      okText: '确定',
      okType: 'danger',
      cancelText: '取消',
      onOk() {
        deleteFiles({ ids: [id] }).then(res => {
          message[res.status ? 'success' : 'error'](res.message);
          res.status && self.getData();
        })
      },
      onCancel() {
        console.log('Cancel');
      },
    });
  }

  downCount (id) {
    const self = this;
    addFileDownCount({ id }).then(res => {
      message[res.status ? 'success' : 'error'](res.message);
      res.status && self.getData();
    })
  }

  render () {
    const self = this;
    const { rows, total, searchObj, entityType, entityId } = this.state;
    const tableViewProps = {
      loading: false,//更新表格数据中
      rowKey: 'id',
      pageParam: {
        total,
        current: searchObj.p,//当前页码
        pageSize: searchObj.s,//当前分页数
        onChange: this.pageChange
      },
      columns: [
        {
          title: '标题',
          dataIndex: 'fileName',
        },
        {
          title: '创建时间',
          dataIndex: 'createdDate',
          render: (text) => new Date(text).format('yyyy-MM-dd hh:mm')
        },
        {
          title: '下载次数',
          dataIndex: 'downloadCount',
        },
        {
          title: '类型',
          dataIndex: 'extension',
        },
        {
          title: '大小',
          dataIndex: 'size',
          render: (text, record, index) => text.bytesToSize()
        },
        {
          title: '操作',
          dataIndex: 'fileId',
          render: (text, record, index) => <span>
            <a href={`${config.server}/api/v1/dms/commonAttachUpload/getFileDown?id=${text}`}
               onClick={this.downCount.bind(self, text)}>下载</a>&nbsp;&nbsp;&nbsp;
            <a onClick={this.deleteFile.bind(self, text)}>删除</a>
          </span>
        },
      ],
      rows
    };
    return <div className="dms-body">
      <DmsTab options={['全部附件']} defaultKey={0}>
        <UploadFile entityType={entityType}
                    entityId={entityId}
                    onSuccess={this.getData}/>
        <Button onClick={this.goBack}>返回</Button>
        {/*<Button icon="filter" onClick={this.visibleChange}>筛选</Button>
         <FilterBox  {...filterBoxProps}/>*/}
      </DmsTab>
      <div className="dms-table-box">
        <TableView {...tableViewProps}/>
      </div>
    </div>
  }
}
;
export default withRouter(FileList);


// WEBPACK FOOTER //
// ./src/routes/remark/file.js